import * as mathUtil from '@/common/js/mathutil.js'

export default {
  title: 'Divide integers',
  operation: 'solve-simple-input',
  config: { nProblems: 10, maxPlaces: 4 },
  problem: function () {
    // a ÷ b = c, a = b * c
    var b = mathUtil.randomIntUniform(2, 9) * mathUtil.randomSign()
    var c = mathUtil.randomIntUniform(2, 9) * mathUtil.randomSign()
    var a = b * c

    var aTex = (a >= 0) ? a : '(' + a + ')'
    var bTex = (b >= 0) ? b : '(' + b + ')'
    var lhsTex = aTex + '÷' + bTex

    // question
    var question = []
    question.push({ type: 'string', value: 'Divide.' })

    // answers
    var answers = []
    answers.push({ before: '$' + lhsTex + '=$', value: c })

    // explanation
    var steps = []
    steps.push('Divide the absolute values and determine the sign.<br>' +
               'If the signs are the same, the product is positive.<br>' +
               'If the signs are different, the product is negative.')
    steps.push('$' + lhsTex + '=' + c + '$')

    return { question: question, answers: answers, explanation: steps }
  }
}



// WEBPACK FOOTER //
// ./src/math/drills/int/intbnxl.js